import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import { messageShow } from "../../common/api/actions";
import BrandedLoading from "../../common/BrandedLoading";
import SectionPaper from "../../common/SectionPaper";
import { nullToEmptyString } from "../../../setup/helpers";
import { Typography, Button, TextField, Toolbar, IconButton } from "@mui/material";
import Grid from "@material-ui/core/Grid/Grid";
import ArrowBack from '@mui/icons-material/ArrowBack';
import styles from "./styles";

import routes from "../api/routes";
import { createOrUpdateKnowledge } from "../api/actions/mutation";

class CreateOrUpdateKnowledge extends Component {
  constructor(props) {
    super(props);
    this.knowledge = {
        _id: "",
        name: "",
    };
    this.state = {
        knowledge: this.knowledge,
        isLoading: false,
        isLoadingSubmit: false,
    };
  }

  componentDidMount() {
    const { location } = this.props;
    if (location.state && location.state.category) {
      this.setState({
        knowledge: {
          _id: location.state.category._id,
          name: location.state.category.name,
        }
      });
    }
  }

  onCreateOrUpdate = async (event) => {
    event.preventDefault();
    const { createOrUpdateKnowledge, messageShow, history } = this.props;
    const { knowledge } = this.state;
    this.isLoadingSubmitToggle(true);
    
    try {
      const { data } = await createOrUpdateKnowledge(knowledge);
      this.isLoadingSubmitToggle(false);
      messageShow(data.message);

      if (data.success) {
        history.push(routes.intentsList.path);
      }
    } catch (error) {
      this.isLoadingSubmitToggle(false);
      console.error("Error during submission:", error);
      messageShow("Some error occurred. Please try again.");
    }
  };

  onType = (event) => {
    const { knowledge } = this.state;
    const { name, value } = event.target;
    knowledge[name] = value;
    this.setState({ knowledge });
  };
  
  isLoadingToggle = (isLoading) => {
    this.setState({
      isLoading,
    });
  };

  isLoadingSubmitToggle = (isLoadingSubmit) => {
    this.setState({
      isLoadingSubmit,
    });
  };

  render() {
    const {
        classes,
      } = this.props;
    const { knowledge, isLoading, isLoadingSubmit } = this.state;
    return (
      <div>
        <Toolbar className={classes.toolbar}>
          <IconButton
            className={classes.menuButton}
            color="inherit"
            onClick={() => this.props.history.push("/intents")}
          >
            <ArrowBack />
          </IconButton>

          <Typography variant="h6" color="inherit" className={classes.grow}>
            {knowledge._id ? "Update Knowledge Category" : "Create Knowledge Category"}
          </Typography>
        </Toolbar>

        <Grid item xs={12} lg={6}>
          <SectionPaper padding>
            {isLoading ? (
              <BrandedLoading />
            ) : (
              <form onSubmit={this.onCreateOrUpdate}>

                <Grid item xs={12} style={{ marginBottom: 24 }}>
                  <TextField
                    name={"name"}
                    variant="standard"
                    value={nullToEmptyString(knowledge?.name)}
                    onChange={this.onType}
                    label={"Knowledge Category"}
                    placeholder={"Enter Knowledge Category"}
                    required={true}
                    margin={"dense"}
                    autoComplete={"off"}
                    fullWidth
                    autoFocus
                  />
                </Grid>

                <Grid item xs={12} style={{ marginTop: 44 }} className={classes.buttonsContainer}>
                  <Button
                    type={"button"}
                    aria-label={"Close"}
                    variant="outlined"
                    color="secondary"
                    onClick={() => this.props.history.push("/intents")}
                  >
                    Cancel
                  </Button>
                  <Button
                    style={{ marginInlineStart: 12 }}
                    type={"submit"}
                    aria-label={"Save"}
                    color={"primary"}
                    variant="contained"
                    disabled={isLoadingSubmit}
                  >
                    Save
                  </Button>
                </Grid>
              </form>
            )}
          </SectionPaper>
        </Grid>
      </div>
    );
  }
}

CreateOrUpdateKnowledge.propTypes = {
    createOrUpdateKnowledge:  PropTypes.func.isRequired,
    messageShow: PropTypes.func.isRequired
};

export default connect(null, { messageShow, createOrUpdateKnowledge })(
  withRouter(withStyles(styles)(CreateOrUpdateKnowledge))
);